<template>
    <base-layout :moduleCode="moduleCode">
        <template v-slot:main>
            <slot></slot>   
        </template>        
    </base-layout>
</template>

<script>
    
    import ModuleMixin from '../shared/mixins/ModuleMixin';

    export default {
        mixins: [
            ModuleMixin,
        ],
    }

</script>